import styled from "styled-components";
import { Button } from "@mui/material/";
import { styled as muiStyled } from "@mui/material/styles/";
import { primaryColor, secondaryColor } from "../../../global/constants";

export const BillersContent = styled.div`
  display: flex;
  color: white;
  flex-direction: column;
  height: 90vh;
  justify-content: space-between;
  overflow-y: auto;
`;

export const ButtonContent = styled.div`
  padding: 5% 10% 0 10%;
`;
export const ProceedButton = muiStyled(Button)({
  textAlign: "center",
  textTransform: "none",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  backgroundColor: primaryColor,
  height: "50px",
  border: "none",
  width: "100%",
  "&:hover": {
    backgroundColor: secondaryColor,
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: secondaryColor,
  },
});

export const FieldContent = styled.div`
  padding-bottom: 20px;
  padding: 5% 10% 0 10%;
  display: flex;
  flex-direction: column;
`;

export const UnderCaption = styled.div`
  padding-top: 10px;
  width: 100%;
  font-size: 13px;
  font-style: italic;
`;
